import { AnimationVariables, ICheckboxStyleProps, ICheckboxStyles, ILabelStyles, IPivotStyleProps, IPivotStyles, IStyleSet } from "@fluentui/react";

export const dropdownStyles = {};

// export const comboBoxStyles = { root: {} };
export const comboBoxStyles = {};


export const _pivotStyles = (props: IPivotStyleProps): Partial<IPivotStyles> => {
  const { theme } = props;
  const { palette } = theme;

  return {
    root: {
      padding: "0px 6px",
    },
    link: [
      {
        borderRadius: "6px 6px 0px 0px",
        marginRight: "4px",
        backgroundColor: palette.neutralLight
      },
      {
        selectors: {
          ':hover': {
            backgroundColor: palette.themeLight,
            color: palette.neutralDark,
          },
          ':active': {                                    // clicked (while mouse button is pressed)
            backgroundColor: palette.themeLighter,
            color: palette.neutralDark,
          }
        }
      }
    ],
    // linkIsSelected: []
  };
};



export const stylesTextFieldSupressDisabledLookFN = (suppress: boolean) => {
  const substituteColor = 'revert';
  return {
      field: {
        color: suppress ? substituteColor : null,
      },
      subComponentStyles: { 
        label: {
          root: {
            color: suppress ? substituteColor : null   //                 
          }
        }
      }
    };
  };

  export const stylesDropdownSupressDisabledLookFN = (suppress: boolean) => {
    const substituteColor = 'revert';
    return {
      label: {
        color: suppress ? substituteColor : null,
      },
      title: {
        color: suppress ? substituteColor : null,
      },
    };
  };


  export const stylesComboBoxSupressDisabledLookFN = (suppress: boolean) => {
    const substituteColor = 'revert';
    return {
      labelDisabled: {
        color: suppress ? substituteColor : null,
      },
      inputDisabled: {
        color: suppress ? substituteColor : null,
      },
    };
  };


  export const stylesCheckBoxSupressDisabledLookFN = (suppress: boolean) => {
    const substituteColor = 'revert';
    return {
      text: {
        color: suppress ? substituteColor : null,
      },

    };
  };

  export const stylesCheckBoxSupressDisabledLookFNX = (props: ICheckboxStyleProps): ICheckboxStyles => {
    // const substituteColor = 'revert';
    const substituteColor = 'red';
    return {
      text: props.disabled && {
        // color: suppress ? substituteColor : null,
        color: substituteColor,
      },

    };
  };


  export const stylesChoiceGroupSupressDisabledLookFN = (suppress: boolean) => {
    const substituteColor = 'red';
    return {
        root: {
        label: {
          color: suppress ? substituteColor : null,
        },
        choiceFieldWrapper: {
          color: suppress ? substituteColor : null,
        },
        field: {
          color: suppress ? substituteColor : null,
        },      },
      label: {
        color: suppress ? substituteColor : null,
      },
      flexContainer: {
        color: suppress ? substituteColor : null,
      },
    };
  };